import React, { useState, useRef, useEffect } from "react";
import { FaCaretDown, FaCog } from "react-icons/fa";

function Dropdown({ options, id }) {
  const [showDropdown, setShowDropDown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropDown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <span className="relative" ref={dropdownRef}>
      <button
        className="text-blueGray-500 px-3 flex items-center justify-between gap-1 border rounded-full"
        onClick={() => setShowDropDown(!showDropdown)}
      >
        <FaCog className="text-d-bg-text" />
        <FaCaretDown className="text-gray-400" />
      </button>
      <div
        className={
          (showDropdown ? "block " : "hidden ") +
          "absolute top-4 left-0 -translate-x-[75%] bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-40"
        }
      >
        {options.map((option, index) => (
          <button
            key={index}
            className="text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            onClick={() => {
              option.func(id);
              setShowDropDown(false);
            }}
          >
            {option.icon}
            <p>{option.name}</p>
          </button>
        ))}
      </div>
    </span>
  );
}

export default Dropdown;
